const PageArticle = () => import('@/modules/finance/article/PageArticle')
const PageProduct = () => import('@/modules/finance/product/PageProduct')
const PageRecommendProduct = () => import('@/modules/finance/product/PageRecommendProduct')
const PageRoadshow = () => import('@/modules/finance/roadshow/PageRoadshow')
const PageBank = () => import('@/modules/finance/bank/PageBank')
const PageAdviser = () => import('@/modules/finance/adviser/PageAdviser')
const PageOrg = () => import('@/modules/finance/org/PageOrg')
const PageFund = () => import('@/modules/finance/fund/PageFund')
const PageComment = () => import('@/modules/finance/comment/PageComment')
const PageProject = () => import('@/modules/finance/project/PageProject')
const PageInvestment = () => import('@/modules/finance/investment/PageInvestment')
const PageBroker = () => import('@/modules/finance/broker/PageBroker')
const PageRoadshowhall = () => import('@/modules/finance/roadshowhall/PageRoadshowhall')
const PageAttention = () => import('@/modules/finance/attention/PageAttention')

export default [

  {
    path: '/finance/article',
    name: 'financeArticle',
    component: PageArticle,
    meta: {
      title: '文章管理',
      isBlack: true
    },
  },
  {
    path: '/finance/product',
    name: 'financeProduct',
    component: PageProduct,
    meta: {
      title: '产品管理',
      isBlack: true
    },
  },
  {
    path: '/finance/recommendproduct',
    name: 'financeRecommendProduct',
    component: PageRecommendProduct,
    meta: {
      title: '金融产品推荐',
      isBlack: true
    },
  },
  {
    path: '/finance/roadshow',
    name: 'financeRoadshow',
    component: PageRoadshow,
    meta: {
      title: '路演管理',
      isBlack: true
    },
  },
  {
    path: '/finance/bank',
    name: 'financeBank',
    component: PageBank,
    meta: {
      title: '金融机构管理',
      isBlack: true
    },
  },
  {
    path: '/finance/org',
    name: 'financeOrg',
    component: PageOrg,
    meta: {
      title: '担保机构管理',
      isBlack: true
    },
  },
  {
    path: '/finance/adviser',
    name: 'financeAdviser',
    component: PageAdviser,
    meta: {
      title: '金融顾问管理',
      isBlack: true
    },
  },
  {
    path: '/finance/fund',
    name: 'financeFund',
    component: PageFund,
    meta: {
      title: '基金管理',
      isBlack: true
    },
  },
  {
    path: '/finance/comment',
    name: 'financeComment',
    component: PageComment,
    meta: {
      title: '留言管理',
      isBlack: true
    },
  },
  {
    path: '/finance/project',
    name: 'financeProject',
    component: PageProject,
    meta: {
      title: '项目资源管理',
      isBlack: true
    },
  },
  {
    path: '/finance/investment',
    name: 'financeInvestment',
    component: PageInvestment,
    meta: {
      title: '投资机构管理',
      isBlack: true
    },
  },
  {
    path: '/finance/broker',
    name: 'financeBroker',
    component: PageBroker,
    meta: {
      title: '券商服务',
      isBlack: true
    },
  },
  {
    path: '/finance/roadshowhall',
    name: 'financeRoadshowhall',
    component: PageRoadshowhall,
    meta: {
      title: '路演大厅管理',
      isBlack: true
    },
  },
  {
    path: '/finance/attention',
    name: 'financeAttention',
    component: PageAttention,
    meta: {
      title: '我的关注',
      isBlack: true
    },
  },
  {
    path: '/zlxxAlliance',
    name: 'zlxxAlliance',
    component:  () => import('@/modules/finance/zlxxAlliance/Page.vue'),
    meta: {
      title: '战新联盟',
      isBlack: true
    },
  },

]
